import { styled } from '@linaria/react'
import { Button, ButtonSC } from 'atoms/Button'
import { InputLabel, InputSC } from 'atoms/Input'
import { AvatarBlockStyled } from 'blocks/AvatarBlock'
import { InputBlockStyled } from 'blocks/InputBlock'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { MEDIA } from 'vars/media'

export const BackButtonSC = styled(Button)`
  &[data-arcana-button='true'] {
    position: absolute;
    top: 16px;
    left: 8px;

    ${MEDIA.MIN_1240} {
      top: 40px;
      left: 40px;
    }
  }
`

export const CreateProfileSC = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(${FIXED_INDENTS.INDENT_220});
  flex-wrap: wrap;
  width: 100%;
  padding-top: var(${FIXED_INDENTS.INDENT_40});

  ${MEDIA.MIN_600} {
    padding-top: var(${FIXED_INDENTS.INDENT_50});
  }

  ${MEDIA.MIN_1240} {
    padding-top: var(${FIXED_INDENTS.INDENT_100});
  }

  ${AvatarBlockStyled} {
    --avatarMaxWidth: 116px;

    max-width: var(--avatarMaxWidth);
  }

  ${MEDIA.MAX_599} {
    gap: var(${FIXED_INDENTS.INDENT_40});
    height: 100%;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: max-content 1fr;
    justify-items: center;
  }
`

export const FormSC = styled.form`
  display: flex;
  flex-direction: column;
  gap: var(${FIXED_INDENTS.INDENT_60});

  ${MEDIA.MIN_1240} {
    gap: var(${FIXED_INDENTS.INDENT_100});
  }
`

export const CreateProfileFormSC = styled.div`
  --formMaxWidth: 100%;

  display: flex;
  flex-direction: column;
  gap: var(${FIXED_INDENTS.INDENT_60});
  max-width: var(--formMaxWidth);
  width: 100%;
  padding: var(${FIXED_INDENTS.INDENT_140}) var(${FIXED_INDENTS.INDENT_40});

  ${MEDIA.MIN_600} {
    --formMaxWidth: 352px;

    padding: var(${FIXED_INDENTS.INDENT_140}) 0;
  }

  ${MEDIA.MIN_1240} {
    gap: var(${FIXED_INDENTS.INDENT_120});
    padding: 0;
  }

  ${MEDIA.MIN_1920} {
    gap: var(${FIXED_INDENTS.INDENT_160});
  }

  ${InputBlockStyled} {
    margin: 0;
  }

  ${InputSC} {
    --inputHeight: 47px;
    height: var(--inputHeight);
  }

  ${InputLabel} {
    gap: var(${FIXED_INDENTS.INDENT_40});
  }

  ${ButtonSC} {
    width: 100%;
  }
`
